import React, { useEffect, useState } from "react";
import TimePopup from "./TimePopup"; // не забудь создать этот компонент

export default function TimeSelectionPage() {
  const [selectedData, setSelectedData] = useState({
    date: "",
    time: "",
    guests: 1,
  });

  const [timeSlots, setTimeSlots] = useState([]);
  const [activeSlot, setActiveSlot] = useState(null);

  useEffect(() => {
    const date = localStorage.getItem("selectedDate");
    const time = localStorage.getItem("selectedTime");
    const guests = localStorage.getItem("selectedGuests");

    setSelectedData({ date, time, guests });

    const slots = [];
    const start = new Date();
    start.setHours(12, 30, 0, 0);
    const end = new Date();
    end.setHours(23, 30, 0, 0);

    while (start <= end) {
      const h = start.getHours().toString().padStart(2, "0");
      const m = start.getMinutes().toString().padStart(2, "0");
      slots.push(`${h}:${m}`);
      start.setMinutes(start.getMinutes() + 30);
    }

    setTimeSlots(slots);
  }, []);

  return (
    <div
      className="min-h-screen bg-cover bg-center flex items-center justify-center px-4 py-10"
      style={{
        backgroundImage: "url('/bg.png')",
      }}
    >
      <div className="w-full max-w-3xl bg-[#F1F1F1] rounded-md shadow-2xl p-6 text-center">
        {/* Header */}
        <div className="flex justify-center">
          <div className="text-xs text-right text-gray-700 mb-4">
            {selectedData.date} · {selectedData.guests} Guest
            {selectedData.guests > 1 && "s"} · {selectedData.time}
          </div>
        </div>

        <h2 className="text-md text-neutral-800 font-base mb-8">
          Select a time at Nammos Dubai
        </h2>

        {/* Grid of time slots */}
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mb-8">
          {timeSlots.map((slot, idx) => {
            const hour = parseInt(slot.split(":")[0]);
            const type = hour < 18 ? "Lunch" : "Dinner";

            return (
              <div
                key={idx}
                onClick={() => setActiveSlot({ time: slot, type })}
                className="bg-white border border-gray-300 py-2 px-2 hover:bg-gray-100 cursor-pointer text-center rounded"
              >
                <div className="text-md font-medium">{slot}</div>
                <div className="text-xs text-gray-500 flex justify-center items-center gap-1 mt-1">
                  {type} <span title="Info">ⓘ</span>
                </div>
              </div>
            );
          })}
        </div>

        <div className="text-sm text-left text-gray-700">
          Other dates with availability
        </div>
        <div className="text-xs text-neutral-600 mt-6">
          Experience By SEVENROOMS
        </div>
      </div>

      {/* Popup */}
      {activeSlot && (
        <TimePopup
          time={activeSlot.time}
          type={activeSlot.type}
          onClose={() => setActiveSlot(null)}
        />
      )}
    </div>
  );
}
